import styles from "./BillingToggle.module.css";

export type BillingPeriod = "monthly" | "yearly";

interface BillingToggleProps {
	period: BillingPeriod;
	onPeriodChange: (period: BillingPeriod) => void;
	showSavings?: boolean;
}

export function BillingToggle({
	period,
	onPeriodChange,
	showSavings = true,
}: BillingToggleProps) {
	return (
		<div className={styles.container}>
			<div className={styles.toggle}>
				<button
					type="button"
					className={`${styles.option} ${period === "yearly" ? styles.active : ""}`}
					onClick={() => onPeriodChange("yearly")}
				>
					Annual
					{showSavings && period === "yearly" && (
						<span className={styles.savings}>Save 10%</span>
					)}
				</button>
				<button
					type="button"
					className={`${styles.option} ${period === "monthly" ? styles.active : ""}`}
					onClick={() => onPeriodChange("monthly")}
				>
					Monthly
				</button>
			</div>
		</div>
	);
}
